import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Button from '@mui/material/Button';
import { makeStyles } from '@material-ui/styles';
import DeleteIcon from '@mui/icons-material/Delete';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import { maxWidth } from '@mui/system';
import ButtonBase from '@mui/material/ButtonBase';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Divider from '@mui/material/Divider';
import { Link } from 'react-router-dom';

import secureAxios from '../../secureAxios';
import IBackdrop from '../backdrop.js';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import TextField from '@mui/material/TextField';

import Web3 from "web3";

import web3ModalConfig from "../../providerOption";
import { ethers } from 'ethers';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import InputLabel from '@mui/material/InputLabel';


import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"assetProtectionRole","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"betaDelegateWhitelister","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"proposedOwner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"EIP712_DOMAIN_HASH","outputs":[{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"supplyController","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"currentOwner","type":"address"},{"indexed":true,"name":"proposedOwner","type":"address"}],"name":"OwnershipTransferProposed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldProposedOwner","type":"address"}],"name":"OwnershipTransferDisregarded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"AddressFrozen","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"AddressUnfrozen","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"FrozenAddressWiped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldAssetProtectionRole","type":"address"},{"indexed":true,"name":"newAssetProtectionRole","type":"address"}],"name":"AssetProtectionRoleSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"SupplyIncreased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"SupplyDecreased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldSupplyController","type":"address"},{"indexed":true,"name":"newSupplyController","type":"address"}],"name":"SupplyControllerSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"},{"indexed":false,"name":"seq","type":"uint256"},{"indexed":false,"name":"fee","type":"uint256"}],"name":"BetaDelegatedTransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldWhitelister","type":"address"},{"indexed":true,"name":"newWhitelister","type":"address"}],"name":"BetaDelegateWhitelisterSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"newDelegate","type":"address"}],"name":"BetaDelegateWhitelisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldDelegate","type":"address"}],"name":"BetaDelegateUnwhitelisted","type":"event"},{"constant":false,"inputs":[],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"initializeDomainSeparator","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_proposedOwner","type":"address"}],"name":"proposeOwner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"disregardProposeOwner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"claimOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"reclaimBUSD","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newAssetProtectionRole","type":"address"}],"name":"setAssetProtectionRole","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"freeze","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"unfreeze","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"wipeFrozenAddress","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"isFrozen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newSupplyController","type":"address"}],"name":"setSupplyController","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"increaseSupply","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"decreaseSupply","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"target","type":"address"}],"name":"nextSeqOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"sig","type":"bytes"},{"name":"to","type":"address"},{"name":"value","type":"uint256"},{"name":"fee","type":"uint256"},{"name":"seq","type":"uint256"},{"name":"deadline","type":"uint256"}],"name":"betaDelegatedTransfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"r","type":"bytes32[]"},{"name":"s","type":"bytes32[]"},{"name":"v","type":"uint8[]"},{"name":"to","type":"address[]"},{"name":"value","type":"uint256[]"},{"name":"fee","type":"uint256[]"},{"name":"seq","type":"uint256[]"},{"name":"deadline","type":"uint256[]"}],"name":"betaDelegatedTransferBatch","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"isWhitelistedBetaDelegate","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newWhitelister","type":"address"}],"name":"setBetaDelegateWhitelister","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"whitelistBetaDelegate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"unwhitelistBetaDelegate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]


const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  });
  
  

  const data = {
      'miningCapital': '0',
      'lockedCapital': '0',
      'availableCapital': '0',
      'totalReward': '0',
      'rewards': {
        directReward: '0',
        miningReward: '0',
      },
      teamRewadrs:[
        {'coin_name': 'USDT', 'amount': 0},
        {'coin_name': 'VET', 'amount': 0},
        {'coin_name': 'OPEN', 'amount': 0},
        {'coin_name': 'WIN', 'amount': 0}
      ],
      availableBalances:[
        {'coin_code': 'USDT', 'balance': 0},
        {'coin_code': 'VET', 'balance': 0},
        {'coin_code': 'OPEN', 'balance': 0},
        {'coin_code': 'WIN', 'balance': 0}
      ],
      'balance': '0',
      'withdrawnAmount': '0'
  }

  const profileSummary = {
    teamCount: 5,
    totalStake: '30.000 HZR',
    rewards: 22.208,
    totalRewardinDollar: 477.703,
    withdrawl: 27.710,
    withdrawlUSD: 590.051
  }

  const rewards = ['Direct Reward', 'Farming Reward'];
  
  const profileSummaryTexts = ['My Team', 'My Stakeing', 'Total Rewards', 'Total Rewards (USD)', 'Total Withdrawals', 'Total Withdrawals (USD)']

  function generate(element) {
      return [0, 1, 2].map((value) =>
        React.cloneElement(element, {
          key: value,
        }),
      );
    }
  
    const Demo = styled('div')(({ theme }) => ({
      backgroundColor: 'transparent',
    }));
  
  
    const useStyles = makeStyles(theme => ({
      root: {
        height: '100%',
        borderBottomRightRadius: '40px',
        borderRadius: '5px'
      },
      content: {
        alignItems: 'center',
        display: 'flex'
      },
      title: {
        fontWeight: 'bold',
        color: 'rgb(33, 43, 54)'
      },
      subItemtitle: {
        color: 'rgb(33, 43, 54)',
        opacity: '0.6',
        fontSize: '8px'
      },
      
      icon: {
        height: 32,
        width: 32
      },
      cardBackground: {
        backgroundColor: '#f0f5f9',
        maxWidth: '300px'
        //padding: 2
      },
      progressBar:{
        width: '50%',
        maxWidth: '200px',
        margin: 'auto'
      },
      pan: {
        boxShadow:  'rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px;',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
        background: 'rgb(255, 255, 255)'
      }
    }));

    const text = {
        color: "rgb(33, 43, 54)",
        opacity: '0.7',
        fontSize: '11px',
        maxWidth: '150px'
    };

    const subItemtitle = {
      color: 'rgb(33, 43, 54)',
      fontSize: '13px'
    };
  
  const Dashboard = (props) => {
      const { className, tileDilogue, onClicked, ...rest } = props;
      const classes = useStyles();
      const [dense, setDense] = React.useState(false);
      const [secondary, setSecondary] = React.useState(false);
      const [open, setOpen] = React.useState(false);
      const [dialogopen, setDialogOpen] = React.useState(false);
      
      const [transferdialogopen, setTransferDialogOpen] = React.useState(false);
      const [renewDialog, setRenewDialog] = React.useState(false);
      const [userDetails, setUserDetails] = React.useState(data);
      const [amount, setAmount] = React.useState(0);
      const [stakeamount, setStakeAmount] = React.useState(0);
      const [address_or_pin, setAddressOrPin] = React.useState('');
      const [renewamount, setRenewamount] = React.useState(0);
      const [pin, setPin] = React.useState('');
      const [stakedialogopen, setStakeDialogOpen] = React.useState(false);
      const [delay, setDelay] = React.useState(100); 
      const [qr_code_show, setQRCODESHOW] = React.useState(false);
      const [coin_code, setCoinCOde] = React.useState('usdt');

      const cameraConfig = {
        facingMode: { exact: "user" }, // Set to "user" for front camera
      };

      const customRanges = [
        { min: 50, max: 500, label: "Range 1" },
        { min: 501, max: 1500, label: "Range 2" },
        { min: 1501, max: 2500, label: "Range 3" },
        { min: 2501, max: 100000, label: "Range 3" },
        // Add more custom ranges as needed
      ];
      
      const handleCoinChange = (event) => {
        setCoinCOde(event.target.value);
      };

      const previewStyle = {
        height: 240,
        width: 320,
      }

      // useEffect(() => {
      //   // Request camera access
      //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      //     navigator.mediaDevices
      //       .getUserMedia({ video: false })
      //   }
      // }, []);

      const handleScan = (data) => {
        setAddressOrPin(data);
        //setQRCODESHOW(false);
      }

      const handleError = (err) => {
        console.error(err)
      }

      const checkRange = (amount) => {
        for (const range of customRanges) {
          if (amount >= range.min && amount <= range.max) {
            return true;
          }
        }
        return false;
      }

      

      const createStake = () => {



        let _confirm = window.confirm('Confirm or deny');
        setOpen(true);
        if (_confirm && parseFloat(stakeamount) < 2){
          alert("Stake amount should be getter then 2 USDT");
          setOpen(false);
        }
        else{
          if (!checkRange(stakeamount)){
            alert("Please enter valid amount")
            return;
          }
          if (_confirm == false){
            setOpen(false);
            return
          }
          if (pin == ''){
            alert("Secret Pin Required");
          setOpen(false);
          }
          setStakeDialogOpen(false);
          setOpen(true);
          secureAxios
            .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/stakeinfo`, {stake_amount: parseFloat(stakeamount), is_new_stake: false, pin: parseInt(pin)}).then(response => {
              setOpen(false);
              setStakeAmount(0);
              setPin('');
              alert("Stake Successfully");
              setStakeDialogOpen(false);
              DashboardDetails();
            }).catch(error => {
              setOpen(false);
              setPin('');
              setStakeAmount(0);
              setStakeDialogOpen(false);
              if (error.response.data?.non_field_errors){
                alert(error.response.data?.non_field_errors)
              }
              else{
                alert(error.response.data?.detail)
              }
    
            })
        }
        
      }

      const renew_process = (tx_hash) => {
        secureAxios
            .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/user/renew`, {tx_hash: tx_hash}).then(response => {
              setOpen(false);
              setRenewamount(0);
              alert("Renew Successfully");
              setRenewDialog(false);
              DashboardDetails();
            }).catch(error => {
              setOpen(false);
              setRenewamount(0);
              setRenewDialog(false);
              if (error.response.data?.non_field_errors){
                alert(error.response.data?.non_field_errors)
              }
              else{
                alert(error.response.data?.detail)
              }
    
            })
      }


      const connectWallet = async (sponser_id, amount, pin) => {
        const provider = await web3ModalConfig.connect();
        const library = new ethers.providers.Web3Provider(provider);
        const accounts = await library.listAccounts();
        const network = await library.getNetwork();
        if (network?.chainId != `${process.env.REACT_APP_NETWORK_ID}`){
          alert("Wrong network selected")
          setOpen(false)
          return;
        }
        if (accounts) {
          pay(accounts[0]);
        }
        
    
      };
      
    const pay = async (address) => {
      try{

      
      const to = "0x7c2929aD4F2029C1027e124E192827089E3DbD98"
      let amount = Web3.utils.toWei(renewamount);
      // try {
        let web3;
          if (window.ethereum) {
              web3 = new Web3(window.ethereum);
          } else if (window.web3) {
              web3 = new Web3(window.web3.currentProvider);
          };

        let gasPrice = await web3.eth.getGasPrice();
        
        let _contract = new web3.eth.Contract(abi, '0x55d398326f99059fF775485246999027B3197955', {
          from: address,
        });

        let gasAmount = await _contract.methods.transfer(to, amount).estimateGas({ from: address });

        let contract = new web3.eth.Contract(abi, '0x55d398326f99059fF775485246999027B3197955', {
          from: address,
          gasPrice: gasPrice,
          gas: Web3.utils.toHex(gasAmount)
        });


        let sentInfo = await contract.methods.transfer(to, amount).send({from: address});

        console.log(sentInfo)

        if (sentInfo?.transactionHash) {
          renew_process(sentInfo?.transactionHash)
        }
      }

      catch(e){
        setOpen(false);
        console.log(e)
        alert("Something went wront")
      }

    }

      const createRenew = () => {

        let _confirm = window.confirm('Confirm or deny');
        setOpen(true);
        if (_confirm && parseFloat(renewamount) < 50){
          alert("Renew amount should be getter then 50 USDT");
          setOpen(false);
        }
        else{
          if (_confirm == false){
            setOpen(false);
            return
          }
          setRenewDialog(false);
          setOpen(true);
          connectWallet()
        }
        
      }


      useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

      const DashboardDetails = () => {
        setOpen(true);
        secureAxios
            .get(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/user/dashboard`).then(response => {
              setOpen(false);
              setUserDetails(response.data);
            }).catch(error => {
              setOpen(false);
              if (error.response.data?.non_field_errors){
                alert(error.response.data?.non_field_errors)
              }
              else{
                alert(error.response.data?.detail)
              }
    
            })
      }

      React.useEffect(() => {
        DashboardDetails()
        return
      }, []);

      const handleClose = () => {
        setDialogOpen(false);
        setStakeDialogOpen(false);
        setTransferDialogOpen(false);
        setPin('');
        setStakeAmount(0);
        setAmount(0);
        setRenewamount(0);
        setRenewDialog(false);
        setAddressOrPin('');
        setQRCODESHOW(false);
      };

      const withdraw = () => {
        setDialogOpen(false);
        if (pin == ''){
          alert('Pin Required');
          return
        }
        setOpen(true);
        
        secureAxios
          .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/user/withdraw`, {amount: parseFloat(amount), pin: parseInt(pin), coin_code: coin_code}).then(response => {
            setOpen(false);
            setDialogOpen(false);
            setPin('');
            setCoinCOde('usdt');
            alert("Withdraw Successfully");
            DashboardDetails();
          }).catch(error => {
            setOpen(false);
            setDialogOpen(false);
            setPin('');
            if (error.response.data?.non_field_errors){
              alert(error.response.data?.non_field_errors)
            }
            else{
              alert(error.response.data?.detail)
            }
          })
      }


      const transfer = () => {
        if (pin == ''){
          alert('Pin Required');
          return
        }
        else if (address_or_pin == '' || address_or_pin.length < 8){
          alert('BUSD address or user id required');
          return
        }
        setTransferDialogOpen(false);
        setOpen(true);

        
        secureAxios
          .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/user/transfer`, {amount: parseFloat(amount), pin: parseInt(pin), address_or_pin: address_or_pin}).then(response => {
            setOpen(false);
            setTransferDialogOpen(false);
            setPin('');
            setCoinCOde('usdt');
            alert("Transfer Successfully");
            DashboardDetails();
          }).catch(error => {
            setOpen(false);
            setTransferDialogOpen(true);
            setPin('');
            if (error.response.data?.non_field_errors){
              alert(error.response.data?.non_field_errors)
            }
            else{
              alert(error.response.data?.detail)
            }
          })
      }

    

      return (
      <>
      <IBackdrop isOpen={open} msg={"Signin progress"}/>

       <Paper
       className={classes.pan}
       style={{background: 'rgb(24, 26, 32)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                            secondaryAction={
                            <Button style={{
                              borderRadius: 35,
                              color: 'rgb(33, 43, 54)',
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              border: '0.5px solid rgb(33, 43, 54)',
                              marginBottom: '10px'
                          }} variant="contained">{userDetails?.miningCapital} USDT</Button>}
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Farming Capital'}
                            secondary={'Capital invested for farming'}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>

                        <Link to="/deposit-statement" style={{textDecoration: 'none'}}>
                        <ListItem
                            style={{background: 'rgba(0,0,0,0.3)', borderRadius: '5px'}}
                            secondaryAction={
                            <IconButton edge="end" aria-label="delete">
                                <KeyboardArrowRightIcon style={{color: 'rgb(33, 43, 54)'}}/>
                              
                            </IconButton>
                            }
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Stake Statement'}
                            primaryTypographyProps={{style:{fontSize: '13px'}}}
                            />
                        </ListItem>
                        </Link>
                        
                    </List>
                    <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              color: 'rgb(33, 43, 54)',
                              border: '0.5px solid rgb(33, 43, 54)',
                              minWidth: '250px',
                              marginBottom: '5px',
                              marginTop: '10px'
                          }} onClick={() => setStakeDialogOpen(true)} variant="contained">Restake</Button>
                    {/* <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 9, marginTop: '5px'}} variant="subtitle2">Restake fees 10%</Typography> */}
                    
                    <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              color: 'rgb(33, 43, 54)',
                              border: '0.5px solid rgb(33, 43, 54)',
                              minWidth: '250px',
                              marginBottom: '5px',
                              marginTop: '10px'
                          }} onClick={() => setRenewDialog(true)} variant="contained">Upgrade Account</Button>

                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {/* <Paper
       style={{background: 'transparent', border: '1px solid  rgb(0 0 0 / 14%)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1,
          marginTop: '20px'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                            secondaryAction={
                            <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              border: '0.5px solid rgb(33, 43, 54)',
                              marginBottom: '10px'
                          }} variant="contained">{userDetails?.lockedCapital}</Button>}
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Locked Capital'}
                            secondary={'Locked capital amount'}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>

                        
                    </List>
                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper> */}

      {/* <Paper
       style={{background: 'transparent', border: '1px solid  rgb(0 0 0 / 14%)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1,
          marginTop: '20px'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                            secondaryAction={
                            <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              border: '0.5px solid rgb(33, 43, 54)',
                              marginBottom: '10px',
                          }} variant="contained">{userDetails?.availableCapital}</Button>}
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Available Capital'}
                            secondary={'Available HZR amount'}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>
                        
                    </List>
                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper> */}

      <Paper
      className={classes.pan}
      style={{background: 'rgb(24, 26, 32)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1,
          marginTop: '20px'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Total Reward'}
                            secondary={'Rewards earned by minting'}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>
                          {Object.keys(userDetails?.rewards).map((item, i) => (
                              <ListItem
                                  secondaryAction={
                                  <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 12}} variant="subtitle2">{userDetails?.rewards[item]}</Typography>
                                }
                              >
                                  <ListItemText
                                    className={classes.subItemtitle}
                                    primaryTypographyProps={{style: subItemtitle}}
                                    primary={rewards[i]}
                                  />
                              </ListItem>
                            ))}
                          <Link to="/rewards-statement" style={{textDecoration: 'none'}}>
                            <ListItem
                              style={{background: 'rgba(0,0,0,0.3)', borderRadius: '5px'}}
                              secondaryAction={
                              <IconButton edge="end" aria-label="delete">
                                  <KeyboardArrowRightIcon style={{color: 'rgb(33, 43, 54)'}}/>
                              </IconButton>
                              }
                          >
                              <ListItemText
                              className={classes.title}
                              primary={'Statement'}
                              primaryTypographyProps={{style:{fontSize: '13px'}}}
                              />
                          </ListItem>
                        </Link>
                    </List>
                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper
      className={classes.pan}
      style={{background: 'rgb(24, 26, 32)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1,
          marginTop: '20px'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                            
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Available Balances'}
                            secondary={'Aiailable balances for withdrawal'}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>
                          {userDetails?.availableBalances.map((item, i) => (
                              <ListItem
                                  secondaryAction={
                                  <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 12}} variant="subtitle2">{item?.balance.toFixed(6)}</Typography>
                                }
                              >
                                  <ListItemText
                                    className={classes.subItemtitle}
                                    primaryTypographyProps={{style: subItemtitle}}
                                    primary={item?.coin_code}
                                  />
                              </ListItem>
                            ))}
                    </List>

                    <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              color: 'rgb(33, 43, 54)',
                              border: '0.5px solid rgb(33, 43, 54)',
                              minWidth: '250px',
                              marginBottom: '5px'
                          }} onClick={() => setDialogOpen(true)} variant="contained">Withdraw</Button>
                    <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 9, marginTop: '5px'}} variant="subtitle2">Withdrawal fees 10%</Typography>
                    <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              fontSize: "14px",
                              marginTop: "10px",
                              color: 'rgb(33, 43, 54)',
                              border: '0.5px solid rgb(33, 43, 54)',
                              minWidth: '250px',
                              marginBottom: '5px'
                          }} onClick={() => setTransferDialogOpen(true)} variant="contained">Transfer USDT</Button>
                    <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 9, marginTop: '5px'}} variant="subtitle2">Transfer fees 0%</Typography>

                    
                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper
      className={classes.pan}
      style={{background: 'rgb(24, 26, 32)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1,
          marginTop: '20px'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                            
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Team Rewards'}
                            secondary={'Rewards earned by minting'}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>
                          {userDetails?.teamRewadrs.map((item, i) => (
                              <ListItem
                                  secondaryAction={
                                  <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 12}} variant="subtitle2">{item?.amount.toFixed(6)}</Typography>
                                }
                              >
                                  <ListItemText
                                    className={classes.subItemtitle}
                                    primaryTypographyProps={{style: subItemtitle}}
                                    primary={item?.coin_name.replace("_", " ")}
                                  />
                              </ListItem>
                            ))}
                          <Link to="/team-rewards-statement" style={{textDecoration: 'none'}}>
                            <ListItem
                              style={{background: 'rgba(0,0,0,0.3)', borderRadius: '5px'}}
                              secondaryAction={
                              <IconButton edge="end" aria-label="delete">
                                  <KeyboardArrowRightIcon style={{color: 'rgb(33, 43, 54)'}}/>
                              </IconButton>
                              }
                          >
                              <ListItemText
                              className={classes.title}
                              primary={'Statement'}
                              primaryTypographyProps={{style:{fontSize: '13px'}}}
                              />
                          </ListItem>
                        </Link>
                    </List>
                    
                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper
       className={classes.pan}
       style={{background: 'rgb(24, 26, 32)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1,
          marginTop: '20px',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                    <List dense={dense}>
                        <ListItem
                            secondaryAction={
                            <Button style={{
                              borderRadius: 35,
                              backgroundColor: "transparent",
                              color: 'rgb(33, 43, 54)',
                              fontSize: "14px",
                              border: '0.5px solid rgb(33, 43, 54)',
                              marginBottom: '10px'
                          }} variant="contained">{userDetails?.withdrawnAmount}</Button>}
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Withdrawan Amount'}
                            secondary={'Total withdrwan'}
                            primaryTypographyProps={{style:{fontSize: '13px'}}}
                            secondaryTypographyProps={{style: text}}
                            />
                        </ListItem>
                        <Link to="/withdrawal-statement" style={{textDecoration: 'none'}}>
                          <ListItem
                            style={{background: 'rgba(0,0,0,0.3)', borderRadius: '5px'}}
                            secondaryAction={
                            <IconButton edge="end" aria-label="delete">
                              
                                <KeyboardArrowRightIcon style={{color: 'rgb(33, 43, 54)'}}/>
                              
                            </IconButton>
                            }
                        >
                            <ListItemText
                            className={classes.title}
                            primary={'Transaction Statement'}
                            primaryTypographyProps={{style:{fontSize: '13px'}}}
                            />
                        </ListItem>
                        </Link>
                    </List>
                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 12, 
          marginBottom: '70px', marginTop: '15px'}} variant="subtitle2">
            Each deposit will remain locked as per your selected tier.
      </Typography>


      <Dialog className='dilog_popup' open={transferdialogopen} onClose={handleClose}>
        <DialogTitle>Transfer Confirmation</DialogTitle>
        <DialogContent>
        
          <DialogContentText>
            To transfer please enter your amount
          </DialogContentText>

          <TextField
            margin="dense"
            id="name"
            label="Address or user id"
            type="text"
            fullWidth
            variant="standard"
            value={address_or_pin}
            onChange={(event) => setAddressOrPin(event.target.value)}
          />

          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Amount"
            type="number"
            fullWidth
            variant="standard"
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
          />

          <TextField
            margin="dense"
            id="name"
            label="Secret Pin"
            type="password"
            fullWidth
            variant="standard"
            value={pin}
            onChange={(event) => setPin(event.target.value)}
          />
        
        </DialogContent>
        {!qr_code_show && <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={transfer}>Submit</Button>
        </DialogActions>}
      </Dialog>

      <Dialog className='dilog_popup' open={dialogopen} onClose={handleClose}>
        <DialogTitle>Withdrawal Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To withdrawal please enter your amount
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Amount"
            type="number"
            fullWidth
            variant="standard"
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
          />

        <TextField
            margin="dense"
            id="name"
            label="Secret Pin"
            type="password"
            fullWidth
            variant="standard"
            value={pin}
            onChange={(event) => setPin(event.target.value)}
          />

          <InputLabel style={{marginTop: '10px'}} id="select-label">Select Coin</InputLabel>
          <Select
              labelId="select-label"
              value={coin_code}
              style={{
                marginTop: '10px',
              }}
              fullWidth
              onChange={handleCoinChange}
              displayEmpty
              aria-label="Select an Option"
              MenuProps={{
                anchorOrigin: {
                  vertical: 'top', // Position the anchor menu at the top
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxWidth: '300px', // Set a maximum width for the menu (adjust as needed)
                    width: '100%',
                    marginTop: '-50px', // Add a negative margin-top of -50px to the entire menu box
                  },
                },
              }}
        

            > 
              <MenuItem value={'usdt'}>USDT</MenuItem>
              <MenuItem value={'vEt'}>VET</MenuItem>
              <MenuItem value={'win'}>WIN</MenuItem>
              <MenuItem disabled value={'open'}>OPEN</MenuItem>
            </Select>
        </DialogContent>
        <DialogActions>
          <Button  onClick={handleClose}>Cancel</Button>
          <Button onClick={withdraw}>Submit</Button>
        </DialogActions>
      </Dialog>


      <Dialog className='dilog_popup' open={stakedialogopen} onClose={handleClose}>
        <DialogTitle>Stake Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To stake please enter your amount
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Amount"
            type="number"
            fullWidth
            variant="standard"
            value={stakeamount}
            onChange={(event) => setStakeAmount(event.target.value)}
          />

<TextField
            margin="dense"
            id="name"
            label="Secret Pin"
            type="password"
            fullWidth
            variant="standard"
            value={pin}
            onChange={(event) => setPin(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={createStake}>Submit</Button>
        </DialogActions>
      </Dialog>

      <Dialog className='dilog_popup' open={renewDialog} onClose={handleClose}>
        <DialogTitle>Renew Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To renew please enter your amount
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Amount"
            type="number"
            fullWidth
            variant="standard"
            value={renewamount}
            onChange={(event) => setRenewamount(event.target.value)}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={createRenew}>Submit</Button>
        </DialogActions>
      </Dialog>
      </>
      
      )
  }
  
  export default Dashboard

